import { render } from "./PrintBtn.vue?vue&type=template&id=50888d28"
import script from "./PrintBtn.vue?vue&type=script&lang=js"
export * from "./PrintBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__